module.exports = __webpack_public_path__ + "static/media/car-crash.abcfc51e.svg";